import { I18N } from '@/app'
import { TypeGuards } from '@codeleap/types'
import { Page, QuizQuestion } from '@/types'
import { Learn } from '@/features'

export function showUnansweredQuestionAlert() {
  // Alert({
  //   title: I18N.t('learn.components.lessonQuizWarn.title'),
  //   body: I18N.t('learn.components.lessonQuizWarn.body'),
  // })
}

export function findUnansweredPage(pages: Page[]) {
  const choices = Learn.S.learn.getState()

  return pages?.findIndex(page => {
    if (!page.question) return false
    const questionId = TypeGuards.isObject(page.question) ? page.question.id : page.question
    return TypeGuards.isNil(choices[questionId])
  })
}

export function getQuestionId(question: QuizQuestion | QuizQuestion['id']) {
  return TypeGuards.isObject(question) ? question?.id : question
}
